<ng-container *ngIf="breadcrumbItems$ | async as items">
  <nav
    *ngIf="items.length > 0"
    [attr.aria-label]="'navigation.breadcrumb' | finLocalization"
    class="breadcrumbs-container grid-max-width padding-left-gutter padding-right-gutter ps-small-t ps-xsmall-b center light-type"
    [ngClass]="textClass()"
  >
    <ul class="no-list-style">
      <li class="font-body-2 font-body-small">
        <a [finLink]="'/' + (currentLanguage$ | async)" class="no-decoration breadcrumb-item" [ngClass]="textClass()">{{
          'actions.home' | finLocalization
        }}</a>
      </li>
      <ng-container *ngFor="let item of items">
        <li *ngIf="item.url && item.url !== '/' + (currentLanguage$ | async)" class="font-body-2 font-body-small">
          <span aria-hidden="true" class="ps-xxsmall-x">/</span>
          <span>
            <a
              *ngIf="item.url !== (currentPath$ | async)"
              [finLink]="item.url"
              class="no-decoration breadcrumb-item"
              [ngClass]="textClass()"
              >{{ item.title }}</a
            >
            <span
              *ngIf="item.url === (currentPath$ | async)"
              class="no-decoration medium-type breadcrumb-item"
              [ngClass]="textClass()"
              [attr.aria-current]="'page'"
              >{{ item.title }}
            </span>
          </span>
        </li>
      </ng-container>
    </ul>
  </nav>
</ng-container>
